import { Button, Notice } from "../shared/ds";
import { applyUpdate } from "../shared/pwa/register";
import { useUpdateReady } from "../shared/pwa/use-install";

export function UpdateBanner() {
  const ready = useUpdateReady();
  if (!ready) return null;
  return (
    <Notice tone="info" className="app-update" title="Nova versão disponível" action={<Button type="button" onClick={applyUpdate}>Atualizar</Button>}>
      Atualize para usar a versão mais recente.
    </Notice>
  );
}
